import { useLocation } from "react-router-dom";
import MainComponentWrapper from "../Common/MainComponentWrapper";

const formatUsd = (value) => `USD ${parseFloat(value || 0).toFixed(2)}`;

const StatCard = ({ label, value, icon, tone }) => (
  <article className={`event-my-earnings-stat is-${tone}`}>
    <div className="event-my-earnings-stat-copy">
      <span className="event-my-earnings-stat-label">{label}</span>
      <strong className="event-my-earnings-stat-value">{value}</strong>
    </div>
    <span className="event-my-earnings-stat-icon" aria-hidden="true">
      <i className={`bi ${icon}`}></i>
    </span>
  </article>
);

const CardsSection = ({ isError, isLoading, details, walletDetails }) => {
  const location = useLocation();
  const isOrganizerEarnings = location.pathname === "/organizer/myEarning";
  const isPromoterEarnings = location.pathname === "/promoter/earning";

  const organizerStats = [
    { label: "Total Events", value: details?.totalEvents || 0, icon: "bi-calendar3", tone: "rose" },
    { label: "Total Orders", value: details?.totalTickets || 0, icon: "bi-box-arrow-up", tone: "orange" },
    { label: "Total Sale", value: formatUsd(details?.totalSale), icon: "bi-tag", tone: "violet" },
    { label: "Total Merchant Fee", value: formatUsd(details?.totalMerchantFee), icon: "bi-tag", tone: "violet" },
    { label: "Total Refunded Amount", value: formatUsd(details?.totalRefundedAmount), icon: "bi-tag", tone: "violet" },
    { label: "Total DanzFlo Fee", value: formatUsd(details?.totalAdminAmount), icon: "bi-tag", tone: "violet" },
    { label: "Total Promoter Commission", value: formatUsd(details?.totalPromoterAmount), icon: "bi-tag", tone: "violet" },
    { label: "Total Escrow Amount", value: formatUsd(details?.totalEscrowAmounts), icon: "bi-tag", tone: "violet" },
    { label: "Total Earning", value: formatUsd(details?.totalEarning), icon: "bi-tag", tone: "violet" },
  ];

  const promoterStats = [
    { label: "Total Events", value: details?.totalEvents || 0, icon: "bi-calendar3", tone: "rose" },
    { label: "Total Orders", value: details?.totalTickets || 0, icon: "bi-box-arrow-up", tone: "orange" },
    {
      label: "Total Withdrawal",
      value: formatUsd(walletDetails?.widrawAmmount),
      icon: "bi-tag",
      tone: "violet",
    },
    {
      label: "Total Commission",
      value: formatUsd(details?.totalCommission),
      icon: "bi-tag",
      tone: "violet",
    },
  ];

  const stats = isOrganizerEarnings
    ? organizerStats
    : isPromoterEarnings
    ? promoterStats
    : organizerStats;

  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      <div className="event-my-earnings-stats">
        {stats.map((stat) => (
          <StatCard key={stat.label} {...stat} />
        ))}
      </div>
    </MainComponentWrapper>
  );
};

export default CardsSection;
